import { Button, message, Modal } from 'antd';
import styles from './index.module.less';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { getDetailByVersionId, updateMaterialStatus, downMaterial } from '@/services/source';
import classNames from 'classnames';
import {
  Delete,
  Unshelve,
  Shelve,
  HistoricVersion,
  Download,
  Edit,
  AlertFilled,
} from 'patternx-svg';
import { downLoadFile } from '@/utils/utils';
import { EmptyShaderColor } from 'patternx-svg';
import { deepfind } from '../../element/utils';
interface Props {
  info: any;
  onClose: () => void;
  onEdit: () => void;
  onDelete: (ids: string[]) => void;
  defaultThumbType: string;
  appOption: any[];
  showVersion: Function;
  refresh: Function;
  categorys: any[];
}

const ViewMaterialModal: React.FC<Props> = (props: Props) => {
  const {
    info,
    onClose,
    onEdit,
    onDelete,
    defaultThumbType,
    appOption,
    showVersion,
    refresh,
    categorys,
  } = props;
  const [details, setDetails] = useState(info);
  const [thumbType, setThumbType] = useState(defaultThumbType);

  const getDetails = async () => {
    if (info.currentVersionId) {
      const res = await getDetailByVersionId(info.currentVersionId);
      if (res?.success) {
        setDetails(res?.data?.details);
      }
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const renderApps = useMemo(() => {
    return details?.appList?.map((a: any) => appOption?.find((o) => o.value === a)?.label) || [];
  }, [details, appOption]);

  const onShowVersion = () => {
    showVersion({
      ...details,
      id: details?.materialId,
    });
  };

  const updataHanlde = async (status: string, text: string) => {
    const res = await updateMaterialStatus(status, [details?.materialId]);
    if (res?.success) {
      message.success(text);
      getDetails();
      refresh();
    }
  };

  const onUpdateStatus = async () => {
    const status = details?.onlineStatus === 'osOnline' ? 'osOffline' : 'osOnline';
    const text = details?.onlineStatus === 'osOnline' ? '材质已下架' : '材质已上架';
    if (status === 'osOffline') {
      Modal.confirm({
        title: `是否下架已选材质 ？`,
        content: `下架后，相关应用将无法调用材质，已使用的材质不受影响`,
        okText: '下架',
        okButtonProps: {
          type: 'primary',
          danger: true,
        },
        icon: <AlertFilled size={24} className={classNames('anticon', styles.alertIcon)} />,
        centered: true,
        cancelText: '取消',
        onOk: async () => {
          updataHanlde(status, text);
        },
        onCancel() {},
      });
    } else {
      updataHanlde(status, text);
    }
  };

  const deleteMaterial = () => {
    onDelete([details.materialId]);
  };

  const [imgStyle, setImgStyle] = useState<any>({ width: '100%', height: 'auto' });
  useEffect(() => {
    if (details?.baseThumbnailUrl) {
      const imgEle = new Image();
      imgEle.src = details.baseThumbnailUrl;
      imgEle.onload = function () {
        if (imgEle.width > imgEle.height) {
          setImgStyle({
            width: '100%',
            height: 'auto',
          });
        } else {
          setImgStyle({
            height: '100%',
            width: 'auto',
          });
        }
      };
    }
  }, [details?.baseThumbnailUrl]);

  // 获取层级标签
  const tagsArr = useMemo(() => {
    if (!categorys.length) return;
    function getName(ele: any, labels: any[]) {
      if (ele?.pid) {
        const activeElement = deepfind(categorys, 'id', ele.pid);
        if (activeElement?.id) {
          labels.unshift(activeElement.name);
        }
        getName(activeElement, labels);
      }
    }
    const mapResult: any[] = [];
    (details?.businessCategoryIds || [])?.forEach((curTag: any) => {
      const ele = deepfind(categorys, 'id', curTag);
      if (ele) {
        mapResult.unshift(ele.name);
        if (ele?.pid) {
          getName(ele, mapResult);
        }
      }
    });
    return mapResult;
  }, [details.businessCategoryIds, categorys]);

  return (
    <Modal
      title={details.name}
      open={true}
      onCancel={onClose}
      width={800}
      footer={false}
      style={{ top: 200 }}
      bodyStyle={{ paddingBottom: '44px' }}
    >
      <div className={styles.viewWrap}>
        <div className={styles.left}>
          <div className={styles.icon}>
            {details?.baseThumbnailUrl || details?.transferStatus === 'transfered' ? (
              <img src={details?.baseThumbnailUrl} style={imgStyle} />
            ) : (
              <EmptyShaderColor size={180} />
            )}
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.title}>
            <div className={styles.name}>{details.name}</div>
            {details?.transferStatus === 'transfered' && details?.onlineStatus !== 'osOffline' && (
              <div className={classNames(styles.tag, styles.onLine)}>上架</div>
            )}
            {details?.transferStatus === 'transfered' && details?.onlineStatus === 'osOffline' && (
              <div className={classNames(styles.tag, styles.offLine)}>下架</div>
            )}
            {details?.transferStatus !== 'transfered' && details?.transferStatus !== 'fail' && (
              <div className={classNames(styles.tag, styles.doing)}>转换中</div>
            )}
            {details?.transferStatus === 'fail' && (
              <div className={classNames(styles.tag, styles.fail)}>转换失败</div>
            )}
          </div>
          <div className={styles.seq}>
            <span>最近更新:&nbsp;&nbsp; </span>
            <span>{moment(details.updatedAt).format('YYYY.MM.DD HH:mm')}</span>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>分类</div>
            <div className={styles.content}>{tagsArr?.join(' / ')}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>物理属性</div>
            <div className={styles.content}>{`${details?.firstLevelCategory ?? ''}${
              details?.secondLevelCategory ? ' / ' + details.secondLevelCategory : ''
            }`}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>应用</div>
            <div className={styles.content}>
              {renderApps?.map((a: string) => (
                <span className={styles.app} key={a}>
                  {a}
                </span>
              ))}
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>尺寸</div>
            <div className={styles.content}>{`${details.length ?? ''} x ${
              details.width ?? ''
            } mm`}</div>
          </div>
          <div style={{ marginTop: 67 }}>
            <Button className={styles.btn} danger onClick={deleteMaterial}>
              <Delete size={16} /> 删除
            </Button>
            <Button className={styles.btn} onClick={onUpdateStatus}>
              {details?.onlineStatus !== 'osOffline' ? (
                <span className="flex-ai-center">
                  <Unshelve size={16} /> 下架
                </span>
              ) : (
                <span className="flex-ai-center">
                  <Shelve size={16} /> 上架
                </span>
              )}
            </Button>
            <Button className={styles.btn} onClick={onShowVersion}>
              <HistoricVersion size={16} /> 版本管理
            </Button>
            <Button
              className={styles.btn}
              onClick={async () => {
                const res = await downMaterial(details?.storageFileId, details?.name);
                if (res?.data?.details?.downloadUrl) {
                  downLoadFile(res?.data?.details?.downloadUrl, details?.name);
                }
              }}
            >
              <Download size={16} /> 下载
            </Button>
            <Button
              className={styles.btn}
              style={{ marginRight: 0 }}
              type="primary"
              onClick={onEdit}
            >
              <Edit size={16} /> 编辑
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewMaterialModal;
